import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { handleContactClick } from './Header';

function Footer() {
    const navigate = useNavigate(); // Define navigate function

    return (
        <div>
            <footer className="py-8 bg-gray-50">
                <div className="container mx-auto text-center">
                    <nav className="flex flex-wrap justify-center space-x-6 text-gray-500">
                        <Link to="/services" className="hover:text-gray-700">Services</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <Link to="/" className="hover:text-gray-700">Blogs</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <Link to="/work" className="hover:text-gray-700">Builds</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <button
                            onClick={() => handleContactClick(navigate, () => { })} // Pass a no-op function for setIsMenuOpen
                            className="cursor-pointer hover:text-gray-700"
                        >
                            Contact
                        </button>
                    </nav>
                    <div className="mt-6">
                        <hr className="border-gray-200 w-16 mx-auto" />
                    </div>
                    <div className="mt-6 text-gray-500">
                        <p>GUWAHATI, ASSAM, India</p>
                        <p>© {new Date().getFullYear()} Learn With Stack. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
